import { Component } from '@angular/core';
import { NavController,NavParams,AlertController } from 'ionic-angular';
import { RecoverPasswordPage } from '../recoverpwd/recoverpwd';
import { AppState } from '../../../../app/app.global';
@Component({
  selector: 'login-children-page',
  templateUrl: 'setpwd.html'
})
export class SetPasswordPage {

  user:any;
  pwd:string="";
  cpwd:string="";
  activeFlag:boolean=false;
  constructor(public navCtrl: NavController,public global: AppState,public navParm :NavParams,private alertCtrl: AlertController) {
  	this.user = navParm.data;
  }

  submitPersonInfo(){
  	if(this.pwd==""){
  		let alert = this.alertCtrl.create({
        subTitle: '密码不能为空!',
        buttons: ['确定']
      });
      alert.present();
  	}else if(this.cpwd == ""){
  		let alert = this.alertCtrl.create({
        subTitle: '请输入确定密码!',
        buttons: ['确定']
      });
      alert.present();
  	}else if( this.pwd != this.cpwd){
  		let alert = this.alertCtrl.create({
        subTitle: '两次输入的密码不一样!',
        buttons: ['确定']
      });
      alert.present();
  	}else {
  		this.user['pwd'] = this.pwd;
  		this.postPersonData(this.user);
  	}
  }
  postPersonData(user:any){
	  	//this.webService.post(ACTIVEACCOUNT,this.user,'账号激活').then(anyObj =>this.handleActiveData(anyObj));
	  	this.navCtrl.push(RecoverPasswordPage,{"userId":this.user.id});
  }
  handleActiveData(anyObj:any){
  	if(anyObj.code == "200"){
  		let alert = this.alertCtrl.create({
				  message: '账号已激活',
				  buttons: ['确定']
				  });
			  alert.present();
  	}
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/account/setpwd/setpwd.ts